import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { Product } from "~/providers/product-provider";

interface ProductStoreState {
  productFormOpen: boolean;
  currentProduct?: Product;
  setCurrentProduct: (currentProduct?: Product) => void;
  setProductFormOpen: (productFormOpen: boolean) => void;
}

export const useProductStore = create<ProductStoreState>()(
  devtools((set) => ({
    productFormOpen: false,
    setCurrentProduct(currentProduct) {
      set(() => ({ currentProduct }));
    },
    setProductFormOpen(productFormOpen) {
      set(() => ({ productFormOpen }));
    },
  }))
);
